import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DataPoints } from "../api";

interface ChatComponentReducerState {
    isAnswerLoading: boolean;
    currentSessionId: string | null;
    overAllCurrentSessionDataPoints: { FAQ: Array<DataPoints>; Manuals: Array<DataPoints>; ALL: Array<DataPoints> };
}

const chatComponentReducerInitialState: ChatComponentReducerState = {
    isAnswerLoading: false,
    currentSessionId: null,
    overAllCurrentSessionDataPoints: { FAQ: [], Manuals: [], ALL: [] }
};

const ChatComponentReducer = createSlice({
    name: "chat",
    initialState: chatComponentReducerInitialState,
    reducers: {
        updateIsAnswerLoading: (state, action: PayloadAction<boolean>) => {
            state.isAnswerLoading = action.payload;
        },
        updateCurrentSessionId: (state, action: PayloadAction<string | null>) => {
            state.currentSessionId = action.payload;
        },
        updateOverAllCurrentSessionDataPoints: (
            state,
            action: PayloadAction<{ FAQ: Array<DataPoints>; Manuals: Array<DataPoints>; ALL: Array<DataPoints> }>
        ) => {
            state.overAllCurrentSessionDataPoints = action.payload;
        },
        resetOverAllCurrentSessionDataPoints: state => {
            state.overAllCurrentSessionDataPoints = { FAQ: [], Manuals: [], ALL: [] };
        }
    }
});

export const ChatComponentReducerAction = ChatComponentReducer.actions;

export default ChatComponentReducer.reducer;
